import React, { FC, useContext, useEffect, useState } from 'react'

// Third party
import { AutorenewRounded, Clear } from '@mui/icons-material'
import clsx from 'clsx'
import { useHistory } from 'react-router-dom'
import { useIonRouter } from '@ionic/react'

// Components
import ViewsLoader from '../../loader/ViewsLoader'
import { PaymentMembers } from '../../payment/PaymentMembers/PaymentMembers'
import { SelectPaymentMethod } from '../../payment/SelectPaymentMethod/SelectPaymentMethod'
import { CreditCardPaymentMethod } from '../../payment/CreditCardPaymentMethod/CreditCardPaymentMethod'

// Redux
import { selectedEvent, setSelectedEvent } from '../../../store/events/eventsSlice'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import {
  selectpaymentStatus,
  selectProfileData,
  setPaymentStatus,
} from '../../../store/user/userSlice'
import {
  selectFilteredPaperworkDocuments,
  selectPayTabGrandTotalAccordion,
  selectRegistertrationPaying,
  selectRegistration,
  selectRegistrationByDay,
  selectRegistrationFeesR,
  selectRegistrationTicketsR,
  selectRidersTeamMembersInDb,
  selectRidersTeamMembersR,
  setPaying,
  setRegistrationAc,
} from '../../../store/registration/registrationSlice'
import {
  allDataReset,
  selectSpectatorTicketsR,
  setPaymentDetails,
} from '../../../store/tickets/ticketslice'

import FirestoreService from '../../../services/firestoreService'

import {
  ISelectedCard,
  IUserInterface,
  IUserInterfaceExtended,
} from '../../../models/users/user.interface'
import { UserModel } from '../../../models/users/user.model'
import {
  IOnPayload,
  IPaymentMethodOptions,
  PAYMENT_STATUS,
  PAYMENT_TYPE,
} from '../../../types/payment'

// Services
import helpers from '../../../commonHelpers/helpers'

import { CONST } from '../../../const/const'
import { MESSAGES_CONST } from '../../../const/messages-const'
import useToasterHelper from '../../../helpers/ToasterHelper'
import { CustomError } from '../../../helpers/helpers'
import { eligibleToSign } from '../../../helpers/sign'

import { httpService } from '../../../services/httpService'
import { getPublishedDetailsOfEvent } from '../../../models/interface.helper'
import { isValidRegistrationEventItems } from '../../../helpers/registration-on-event'
import { getFloatPrice } from '../../../helpers/price'
import { HandleModalContext } from '../../../layout/mainlayout/MainLayout'
import { cn } from '../../../lib/utils'

// Constants
import { MODAL_CONSTS } from '../../../const/modal-const'
import { USE_MODE_CONST } from '../../../const/use-mode'
import { getCurrency } from '../../../helpers/payment'

type RegisterForCompetitionPayByCardModalPropsProps = {
  dataToPassOn: {
    isSplitBill: boolean
    defaultPaymentMethod: IPaymentMethodOptions
  }
}

const COLLECTIONS = CONST.DATA.FIRESTORE.V01.COLLECTIONS

const FILE_NAME = 'RegisterForCompetitionPayByCardModal'
const customErrorProps = {
  fileName: FILE_NAME,
  message: MESSAGES_CONST.SOMETHING_WENT_WRONG,
}

const RegisterForCompetitionPayByCardModal: FC<RegisterForCompetitionPayByCardModalPropsProps> = ({
  dataToPassOn,
}) => {
  const handleModalContext = useContext(HandleModalContext)
  const handleModal = handleModalContext?.handleModal

  // Hooks and vars
  const dispatch = useAppDispatch()
  const router = useIonRouter()
  const history = useHistory()
  const toasterFunctions = useToasterHelper()
  const registration = useAppSelector(selectRegistration)
  const selectedEventR = useAppSelector(selectedEvent)
  const paying = useAppSelector(selectRegistertrationPaying)
  const spectator_ticket = useAppSelector(selectSpectatorTicketsR)
  const paymentStatus = useAppSelector(selectpaymentStatus)
  const filteredPaperworksDocuments = useAppSelector(selectFilteredPaperworkDocuments)
  const registrationsClasses = useAppSelector(selectRegistrationByDay)
  const profileData = useAppSelector(selectProfileData)
  const grandTotalAccordionData = useAppSelector(selectPayTabGrandTotalAccordion)
  const registrationTickets = useAppSelector(selectRegistrationTicketsR)
  const registrationFees = useAppSelector(selectRegistrationFeesR)
  const ridersTeamMembers = useAppSelector(selectRidersTeamMembersR)
  const ridersTeamMembersInDb = useAppSelector(selectRidersTeamMembersInDb)

  const { eventMainData, payment_detail } = spectator_ticket
  const { isSplitBill, defaultPaymentMethod } = dataToPassOn
  const isTicketPayment = payment_detail?.type === 'spectator'

  const [amountToPay, setAmountToPay] = useState(0)
  const [stripeRes, setStripeRes] = useState<{ id: string; receipt_url: string }>({
    id: '',
    receipt_url: '',
  })
  const [loading, setLoading] = useState<boolean>(false)
  const [selectedCard, setSelectedCard] = useState<ISelectedCard>({
    type: null,
    pmId: '',
    cardNumber: '',
  })
  const [organizer, setOrganizer] = useState<IUserInterfaceExtended | null>(null)
  const [registrar, setRegistrar] = useState<IUserInterface | null>(null)
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<IPaymentMethodOptions | null>(
    defaultPaymentMethod || null
  )

  useEffect(() => {
    let amount

    if (isTicketPayment) {
      amount = payment_detail?.price
    } else {
      const recipient = grandTotalAccordionData.amountByPerson.find(
        (person) => person.recipientId === registration?.userId
      )
      amount = (isSplitBill ? recipient?.amountToPay : grandTotalAccordionData.totalPrice) || 0
    }

    setAmountToPay(amount || 0)
  }, [payment_detail, isTicketPayment, grandTotalAccordionData, registration, isSplitBill])

  useEffect(() => {
    const getOwnerProfile = async () => {
      const ownerSnapshots = await FirestoreService.getItem(
        COLLECTIONS.USERS.NAME,
        selectedEventR?.basicEventDetails?.owner ?? ''
      )
      const owner = UserModel.fromFirestoreDoc(ownerSnapshots).toObject()

      const userSnapshots = await FirestoreService.getItem(
        COLLECTIONS.USERS.NAME,
        registration?.userId ?? profileData.id ?? ''
      )
      const user = UserModel.fromFirestoreDoc(userSnapshots).toObject()

      setOrganizer(owner)
      setRegistrar(user)
    }
    if (selectedEventR.basicEventDetails?.owner) getOwnerProfile().then()
  }, [registration?.userId, selectedEventR.basicEventDetails?.owner, profileData.id])

  const closeModal = () => {
    if (isTicketPayment && paymentStatus) {
      dispatch(allDataReset())
    }
    dispatch(setPaymentStatus(false))
    handleModal?.(false, 'competitonPayByCard')
  }

  useEffect(() => {
    const getDetailSelectedEvent = async () => {
      const publishedDetails = await getPublishedDetailsOfEvent(eventMainData?.id ?? '')
      if (publishedDetails) dispatch(setSelectedEvent(publishedDetails))
    }

    if (isTicketPayment && eventMainData) {
      getDetailSelectedEvent().then()
    }
  }, [dispatch, eventMainData, isTicketPayment])

  const onViewReceiptClick = async () => {
    if (isTicketPayment) {
      let anchorElement = document.createElement('a')
      anchorElement.target = '_blank'
      anchorElement.href = stripeRes?.receipt_url ?? ''
      document.body.appendChild(anchorElement)
      anchorElement.click()
    } else {
      handleModal?.(false, MODAL_CONSTS.REGISTER_FOR_COMPETITION_PAY_BY_CARD)
      handleModal?.(true, MODAL_CONSTS.BILL_BRIEFE, {
        eventId: registration?.eventId,
        recipientId: registration?.userId,
      })
    }
  }

  const onPayAmount = async () => {
    dispatch(setPaying(true))
    setLoading(true)

    const eventOwnerId = selectedEventR.basicEventDetails.owner
    let eventId: string | null = selectedEventR.basicEventDetails.id ?? null

    const classesItems = registrationsClasses
      .filter((rider) => !rider.isDivision)
      .map(({ id, ...rest }) => ({
        ...rest,
        recipientId: registration?.isSplit ? rest.recipientId : registration?.userId || null,
        recipientName: registration?.isSplit ? rest.recipientName : registration?.userName || null,
        recipientProfilePicture: registration?.isSplit
          ? rest.recipientProfilePicture
          : registration?.userProfilePicture || null,
      }))

    const tickets =
      registrationTickets.map(({ id, ...rest }) => ({
        ...rest,
        recipientId: registration?.isSplit ? rest.recipientId : registration?.userId || null,
        recipientName: registration?.isSplit ? rest.recipientName : registration?.userName || null,
        recipientProfilePicture: registration?.isSplit
          ? rest.recipientProfilePicture
          : registration?.userProfilePicture || null,
      })) ?? []

    const fees =
      registrationFees.map(({ id, ...rest }) => ({
        ...rest,
        recipientId: registration?.isSplit ? rest.recipientId : registration?.userId || null,
        recipientName: registration?.isSplit ? rest.recipientName : registration?.userName || null,
        recipientProfilePicture: registration?.isSplit
          ? rest.recipientProfilePicture
          : registration?.userProfilePicture || null,
      })) ?? []

    let ridersTeamMembersItems = ridersTeamMembers.map(({ id, ...rest }) => ({ ...rest })) ?? []

    // we need to check if we have the same team member in db
    ridersTeamMembersItems =
      ridersTeamMembersItems.filter((ridersTeamMembersItem) => {
        const exist = ridersTeamMembersInDb.find(
          (item) =>
            item.riderId === ridersTeamMembersItem.riderId &&
            item.horseId === ridersTeamMembersItem.horseId &&
            item.teamMemberId === ridersTeamMembersItem.teamMemberId &&
            item.teamMemberRole === ridersTeamMembersItem.teamMemberRole
        )
        return !exist
      }) ?? []

    const { notSignedOwner, isMinorGuardian } = eligibleToSign({
      paperworkDocuments: filteredPaperworksDocuments,
      userId: registration?.userId ?? '',
      ridersTeamMembers: [],
    })

    if (!selectedEventR.basicEventDetails.id) {
      setLoading(false)
      dispatch(setPaying(false))
      return toasterFunctions.error({
        message: MESSAGES_CONST.SOMETHING_WENT_WRONG,
      })
    }

    if (notSignedOwner) {
      setLoading(false)
      dispatch(setPaying(false))
      return toasterFunctions.error({
        message: MESSAGES_CONST.REGISTRATION_EVENT_NOT_SIGNED,
      })
    }

    if (isMinorGuardian) {
      setLoading(false)
      dispatch(setPaying(false))
      return toasterFunctions.error({
        message: MESSAGES_CONST.REGISTRATION_EVENT_GUARDIAN_IS_MINOR,
      })
    }

    if (!selectedPaymentMethod) {
      setLoading(false)
      dispatch(setPaying(false))
      return toasterFunctions.error({
        message: 'Please select a payment method',
      })
    }

    if (selectedPaymentMethod !== 'cash' && !selectedCard?.pmId) {
      setLoading(false)
      dispatch(setPaying(false))
      return toasterFunctions.error({
        message: 'Please select a card',
      })
    }

    const { emptyVarName, emptyVarValue } = helpers.findEmptyVal({
      eventId,
      eventOwnerId,
      ...(!isTicketPayment && {
        userId: registration?.userId,
        registrationId: registration?.id,
      }),
    })

    const { allRecipientsAssigned, allOwnersAssigned } = isValidRegistrationEventItems({
      registrationsByDay: classesItems,
      registrationsFees: fees,
      registrationsTickets: tickets,
    })

    if (!allRecipientsAssigned) {
      setLoading(false)
      dispatch(setPaying(false))
      return toasterFunctions.error({
        message: MESSAGES_CONST.PLEASE_ASSIGN_BILL,
      })
    }

    if (!allOwnersAssigned) {
      setLoading(false)
      dispatch(setPaying(false))
      return toasterFunctions.error({
        message: MESSAGES_CONST.PLEASE_ASSIGN_OWNER,
      })
    }

    if (emptyVarName)
      throw CustomError.somethingWentWrong({
        ...customErrorProps,
        moduleName: 'onPayAmount',
        devMessage: `${emptyVarName} is [${emptyVarValue}]`,
      })

    if (isTicketPayment) {
      eventId = eventMainData?.id ?? null
    }

    const isPayByCash = selectedPaymentMethod === 'cash' || selectedPaymentMethod === 'delayed'

    try {
      if (selectedPaymentMethod === 'delayed') {
        await FirestoreService.updateItem(COLLECTIONS.USERS.NAME, registrar?.id, {
          userStripeDefaultPmId: selectedCard?.pmId,
        })
      }

      const initialPayloadData = {
        paymentType: isPayByCash ? PAYMENT_TYPE.CASH : PAYMENT_TYPE.CARD,
        paymentStatus: isPayByCash ? PAYMENT_STATUS.DEFAULT : PAYMENT_STATUS.PAID,
        amountToPay: isPayByCash ? 0 : amountToPay,
        pmId: selectedCard?.pmId || null,
        cardNumber: selectedCard?.cardNumber || null,
        registrationsByDay: classesItems,
        tickets: tickets,
        fees: fees,
        ridersTeamMembers: ridersTeamMembersItems,
        eventId: selectedEventR?.basicEventDetails?.id || '',
      }

      let payloadData: IOnPayload

      if (registration?.id) {
        payloadData = {
          ...initialPayloadData,
          description: 'Event Registration',
          type: 'event_register',
          registrationId: registration?.id,
          payerId: registration?.userId,
          registrarId: registration?.userId,
          isTicketPayment: false,
        }
      } else if (isTicketPayment) {
        payloadData = {
          ...initialPayloadData,
          description: 'Guest User buy tickets',
          type: 'spectator_tickets',
          registrationId: null,
          payerId: profileData.id,
          registrarId: profileData.id,
          isTicketPayment: true,
        }
      } else {
        toasterFunctions.error({
          message: "Couldn't process your payment. Please try again.",
        })
        return
      }

      const payRes = await httpService({
        url: 'on_pay',
        method: 'POST',
        data: payloadData,
      })

      if (payRes?.paymentIntent?.id) setStripeRes(payRes.paymentIntent)
      dispatch(setPaymentStatus(true))

      if (registration?.id) {
        dispatch(setRegistrationAc({ ...registration, cartItems: null }))
        let link
        if (registration?.id && profileData.userType === USE_MODE_CONST.ORGANIZER) {
          link = `${CONST.ROUTES.MANAGE.CLINIC_N_OTHER.URL}/${registration?.eventId}`
        } else if (registration?.id) {
          link = CONST.ROUTES.MY_EVENT.URL
        } else {
          link = `${CONST.ROUTES.EVENT_DETAILS.URL}/${eventId}`
        }

        router.push(link)
        history.push(link)
      } else if (isTicketPayment) {
        dispatch(
          setPaymentDetails({
            payment_detail: {
              ...payment_detail,
              setLoading,
            },
            payment_status: {
              status: true,
              show_payment_done: false,
              data: payRes?.paymentIntent ?? '',
            },
          })
        )
      }
    } catch (error: any) {
      console.error(error, 'error')
      toasterFunctions.error({
        message: error?.response.data?.response || MESSAGES_CONST.SOMETHING_WENT_WRONG,
      })
    } finally {
      dispatch(setPaying(false))
      setLoading(false)
    }
  }

  /**
   * @info Closes payment tab and opens add new card tab
   */
  const openAddNewCardModal = () => {
    handleModal?.(false, MODAL_CONSTS.REGISTER_FOR_COMPETITION_PAY_BY_CARD)
    handleModal?.(true, MODAL_CONSTS.CARD, {
      ...dataToPassOn,
      add_card: !isTicketPayment,
      re_open_modal: true,
      modal_name: MODAL_CONSTS.REGISTER_FOR_COMPETITION_PAY_BY_CARD,
      organizerId: selectedEventR.basicEventDetails.owner,
      defaultPaymentMethod: selectedPaymentMethod,
      user: registrar,
    })
  }

  /**
   * @info Closes payment tab and opens add new card tab
   */
  const openAddNewBankModal = () => {
    handleModal?.(false, MODAL_CONSTS.REGISTER_FOR_COMPETITION_PAY_BY_CARD)
    handleModal?.(true, MODAL_CONSTS.CONNECT_BANK_ACCOUNT, {
      ...dataToPassOn,
      reOpenModalName: MODAL_CONSTS.REGISTER_FOR_COMPETITION_PAY_BY_CARD,
      user: registrar,
      organizer: organizer,
      defaultPaymentMethod: selectedPaymentMethod,
    })
  }

  /**
   * @info Closes pay using card modal
   */
  const closePayByCardModal = () => {
    if (isTicketPayment) dispatch(allDataReset())
    dispatch(setPaymentStatus(false))
    handleModal?.(false, MODAL_CONSTS.REGISTER_FOR_COMPETITION_PAY_BY_CARD)
  }

  const currency = getCurrency(selectedEventR?.EventPaymentSettings?.currency)

  return (
    <div
      data-type="REGISTER_FOR_COMPETITION_PAY_BY_CARD"
      className={`modal fade fixed z-50 w-full h-screen outline-none flex items-center justify-center overflow-x-hidden overflow-y-auto show d-block backShadow`}
      id="exampleModalCenter"
      aria-labelledby="exampleModalCenterTitle"
      aria-modal="true"
      role="dialog"
    >
      <div
        className={cn(
          'modal-dialog modal-dialog-centered relative w-full max-w-[650px] m-auto pointer-events-none max-h-[90vh]',
          !paymentStatus && 'h-[90vh]'
        )}
      >
        <div
          className={cn(
            'pt-4 sm:pt-6 pb-4 sm:pb-10 modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current',
            !paymentStatus && 'h-full'
          )}
        >
          <span
            onClick={() => {
              if (loading || paying) return
              closeModal()
            }}
            className="absolute text right-2 top-2 text-SeabiscuitDark200ThemeColor cursor-pointer"
          >
            <Clear
              fontSize={'small'}
              style={{
                color: 'grey',
                fontWeight: '400',
              }}
            />
          </span>
          {!paymentStatus && (
            <div className="overflow-auto text-SeabiscuitDark200ThemeColor flex-1 flex flex-col">
              <div className="px-4 sm:px-10 modal-header flex flex-shrink-0 items-center justify-between rounded-t-md">
                <h5 className="text-2xl leading-normal font-bold" id="exampleModalScrollableLabel">
                  Pay
                </h5>
              </div>
              <div className="pt-6 px-4 sm:px-10 min-h-1/2 overflow-y-auto flex-1 scrollbar-none">
                <PaymentMembers isSplitBill={isSplitBill} />
                {!isTicketPayment && <hr className="my-4" />}
                <SelectPaymentMethod
                  selectedEvent={selectedEventR}
                  selectedPaymentMethod={selectedPaymentMethod}
                  setSelectedPaymentMethod={setSelectedPaymentMethod}
                  setSelectedCard={setSelectedCard}
                  availablePaymentMethods={['credit-card', 'ach', 'delayed', 'cash']}
                  isTicketPayment={isTicketPayment}
                />
                {selectedPaymentMethod === 'credit-card' && (
                  <>
                    <hr className="my-6" />
                    <p className="mb-4 text-sm text-black">Select card to pay</p>
                    <CreditCardPaymentMethod
                      availablePaymentMethods={['cards']}
                      selectedPaymentMethod={selectedPaymentMethod}
                      selectedCard={selectedCard}
                      setSelectedCard={setSelectedCard}
                      user={registrar}
                      organizer={organizer}
                      openAddNewCardModal={openAddNewCardModal}
                    />
                  </>
                )}
                {selectedPaymentMethod === 'ach' && (
                  <>
                    <hr className="my-6" />
                    <p className="mb-4 text-sm text-black">
                      Select debit card or bank account to pay
                    </p>
                    <CreditCardPaymentMethod
                      availablePaymentMethods={['cards', 'ach']}
                      selectedPaymentMethod={selectedPaymentMethod}
                      selectedCard={selectedCard}
                      setSelectedCard={setSelectedCard}
                      user={registrar}
                      organizer={organizer}
                      openAddNewCardModal={openAddNewCardModal}
                      openAddNewBankModal={openAddNewBankModal}
                    />
                  </>
                )}
                {selectedPaymentMethod === 'delayed' && (
                  <>
                    <hr className="my-6" />
                    <p className="mb-4 text-sm text-black">
                      Select preferred payment method for future payment
                    </p>
                    <CreditCardPaymentMethod
                      availablePaymentMethods={['cards', 'ach']}
                      selectedPaymentMethod={selectedPaymentMethod}
                      selectedCard={selectedCard}
                      setSelectedCard={setSelectedCard}
                      user={registrar}
                      organizer={organizer}
                      openAddNewCardModal={openAddNewCardModal}
                      openAddNewBankModal={openAddNewBankModal}
                    />
                  </>
                )}
              </div>
              <div className="px-4 sm:px-10">
                <button
                  disabled={paying || loading}
                  type="submit"
                  className="w-full h-12 mx-auto py-2 px-4 mt-5 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-SeabiscuitMainThemeColor hover:bg-[#D70443] focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:text-SeabiscuitLightTextColor disabled:bg-SeabiscuitLightThemeColor focus:ring-SeabiscuitMainThemeColor"
                  onClick={onPayAmount}
                >
                  {(paying || loading) && (
                    <AutorenewRounded fontSize="small" className="animate-spin" />
                  )}
                  {selectedPaymentMethod === 'credit-card' || selectedPaymentMethod === 'ach'
                    ? `Pay ${getFloatPrice(`${currency}${amountToPay}`)}`
                    : 'Submit registration'}
                </button>

                <button
                  disabled={paying || loading}
                  onClick={closePayByCardModal}
                  type="button"
                  className="w-full mt-2 h-12 mx-auto block items-center justify-center py-2 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-SeabiscuitLightTextColor bg-SeabiscuitLightThemeColor hover:bg-[#0b15261a] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-SeabiscuitMainThemeColor"
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
          {paymentStatus && (
            <div className="px-4 sm:px-10">
              <div className="mx-auto w-full mb-5 text-center">
                {!paying ? (
                  <>
                    <img className="mx-auto w-10" src={'assets/img/light/Ok.svg'} alt="icon" />
                    <h6 className="text-center text-SeabiscuitDark200ThemeColor font-semibold mt-3 mb-3">
                      Success!
                    </h6>
                  </>
                ) : (
                  <>
                    <ViewsLoader color="red" size="md" />
                    <h6 className="text-center text-SeabiscuitDark200ThemeColor font-semibold mt-3 mb-3">
                      Processing! please wait
                    </h6>
                  </>
                )}

                {!isTicketPayment ? (
                  <>
                    <p className="text-center text-SeabiscuitDark200ThemeColor mt-3 mb-3">
                      You registered for this event.
                    </p>
                    {(selectedPaymentMethod === 'cash' || selectedPaymentMethod === 'delayed') && (
                      <p className="text-center text-SeabiscuitDark200ThemeColor mt-3 mb-3">
                        You will be required to pay your bill when you arrive at the show.
                      </p>
                    )}
                    <p className="text-center text-SeabiscuitDark200ThemeColor mt-3 mb-3">
                      Each of your team members were sent paperwork to sign .
                    </p>
                  </>
                ) : null}

                <p className="text-center text-SeabiscuitDark200ThemeColor mt-3 mb-3  ">
                  Amount: {getFloatPrice(`${currency}${amountToPay}`)}
                </p>
              </div>
              <button
                disabled={!paymentStatus || paying}
                className={clsx(
                  'mt-auto w-full h-12 mx-auto py-2 px-4 border-2 border-solid border-SeabiscuitMainThemeColor hover:bg-SeabiscuitMainThemeColor rounded-lg shadow-sm text-sm font-medium text-SeabiscuitMainThemeColor hover:text-white bg-[white]  flex items-center justify-center'
                )}
                onClick={onViewReceiptClick}
              >
                VIEW RECEIPT
              </button>
              <button
                disabled={!paymentStatus || paying}
                onClick={closePayByCardModal}
                type="button"
                className="w-full mt-2 h-12 mx-auto block items-center justify-center py-2 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-SeabiscuitLightTextColor bg-SeabiscuitLightThemeColor "
              >
                CLOSE
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default RegisterForCompetitionPayByCardModal
